<template>

  <div class="form-group" v-if="render">
    <label :title="tooltip(element.label)">
      {{ t(element.label) }}
      <icons-render :propIcons="element.icons"/>
    </label>
    <textarea
      v-model="value"
      :name="element.name"
      @keyup="_changeValue"
      @blur="_blur"
      :readonly="element.readonly"
      class="form-control"
      rows="4"
    ></textarea>
    <div
      v-if="!element.readonly"
      @click="_clear"
      class="input-autocomplete-clear"><i class="fa fa-close"></i>
    </div>
  </div>

</template>

<script>
import IconsRender from '../../templates/widgets/icons-render'
import DictionaryLoader         from '@/model/loader/dictionary-loader'

export default {
  name:       'text-area',
  components: {
    IconsRender
  },
  props:      {
    element: {
      required: true,
      type:     Object,
      default:  () => {
        return {
          name:     null,
          type:     null,
          dataType: null,
          label:    null
        }
      }
    }
  },

  data () {
    return {
      value:         '',
      originalValue: '',
      render:        true
    }
  },

  created () {

  },

  methods: {

    /**
     *
     * @param value
     */
    updateValue (value) {
      value = value.value

      this.value         = value
      this.originalValue = value
    },

    /**
     *
     * @param values
     * @param fieldName
     */
    updateHighlighters (values, fieldName) {
      this.element.icons.forEach((icon) => {
        if (icon.def.ColumnName === fieldName) {
          icon.value = JSON.parse(values.value)
        }
      })
    },

    /**
     *
     * @private
     */
    _changeValue () {
      this.$emit('changeValue', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _blur () {
      if (this.originalValue === this.value) {
        return
      }

      this.$emit('blur', { element: this.element, value: this.value })
    },

    /**
     *
     * @private
     */
    _clear () {
      this.value = null

      this._changeValue()
      this._blur()
    },

    setRender (render) {
      this.render = render
    },

    tooltip (key) {
      return DictionaryLoader.tooltip(key, this.$user.languageCode)
    }

  }

}
</script>
